import type { Theme } from '@mui/material/styles';
import { darkTheme, lightTheme } from './index';
import { getAmplifyAuthSurfaceVars } from './uiSemanticColors';

/** Writes `--auth-*` custom properties on `:root` for Amplify login UI. */
export function applyAmplifyAuthSurfaceVars(mode: 'light' | 'dark', theme?: Theme): void {
  const source = theme ?? (mode === 'dark' ? darkTheme : lightTheme);
  const surfaceVars = getAmplifyAuthSurfaceVars(source);
  for (const [key, value] of Object.entries(surfaceVars)) {
    document.documentElement.style.setProperty(key, value);
  }
}
